$(document).ready(function () {
  var stickySection = $('.section-cover');
  if (stickySection.length) {
    var stickyOffset = stickySection.offset().top;
    $(window).scroll(function () {
      var sticky = $('.section-cover'),
        scroll = $(window).scrollTop();

      if (scroll >= stickyOffset) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
    });
  }
});


let $root = $('html, body');
$('a[href^="#"]').click(function () {
  let href = $.attr(this, 'href');
  $root.animate(
    {
      scrollTop: $(href).offset().top,
    },
    500,
    function () {
      window.location.hash = href;
    }
  );
  return false;
});

$(document).ready(function () {
  $(document).on('click', '.tooltip', function () {
    setTimeout(function () {
      var price_p = $('.b_test').find('.span').text();

      $('.price_ch').text(price_p);
      $('.test_price span').css('display', 'none');
    }, 100);
  });

  $(document).on('click', '.btn-1', function () {
    var items = [
      { quantity: 1, id: 41305381601489 },
      { quantity: 1, id: 41305381175505 },
    ];

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: items,
      },
      dataType: 'json',
      success: function (data) {
        document.location.href = '/cart';
      },
    });
  });
});

$(document).ready(function () {

    $('#trigger-overlay').on('click', function () {
        $('.overlay').addClass('open');
        $('button.overlay-close').addClass('show');
        $('#trigger-overlay').addClass('hide');
        $('.navigation-vertical').addClass('active');
        $('.menu-link[data-target="shop-menu"]').addClass('selected');
        $('#header').addClass('fixed-header');
        $('.navigation-fixed').css('display', 'block');

        $('body').css({
            'overflow': 'hidden',
            'position': 'fixed',
            'width': '100%'
        });
    });

    $('.overlay-close').on('click', function () {
        $('.overlay').removeClass('open');
        $('button.overlay-close').removeClass('show');
        $('#trigger-overlay').removeClass('hide');
        $('.navigation-vertical').removeClass('active');
        $('.menu-link').removeClass('selected');
        $('#header').removeClass('fixed-header');
        $('.navigation-fixed').css('display', 'none');

        $('body').css({
            'overflow': '',
            'position': '',
            'width': ''
        });
    });

    $('.menu-link').on('click', function () {
        let targetMenu = $('#' + $(this).data('target'));

        if (targetMenu.length) {
            $('.submenu-container, .navigation-vertical').removeClass('active');
            $('.menu-link').removeClass('selected');

            $('body').css('overflow', 'auto');
            $('html, body').scrollTop(0);
            setTimeout(() => {
                $('body').css('overflow', 'hidden');
            }, 50);

            targetMenu.addClass('active');
            $(this).addClass('selected');
        }
    });

    // Dodane zdarzenie kliknięcia dla togglowania rozwijanej nawigacji
   $('.parent-img-container-and-label').on('click', function () {
    let $parentLi = $(this).closest('li'); 
    let $submenu = $parentLi.find('ul.class_ul').first(); 
    let $chevron = $(this).find('.chevron-up');

    // Zamknij inne submenu i usuń rotated z innych chevronów
    $('ul.class_ul').not($submenu).slideUp();
    $('.chevron-up').not($chevron).removeClass('rotated');

    // Toggle dla klikniętego elementu
    $submenu.slideToggle();
    $chevron.toggleClass('rotated');
});

});




